/* eslint-disable no-unreachable */
/* eslint-disable no-useless-escape */
const logger = require('nordic/logger');
const { CountryOfOperationItems } = require('../utils/constants');

const log = logger('dx-panel-dx-devsite');

const componentCodeFront = (formData, i18n) => {
  try {
    return [
      {
        code: `
<html>
<head>
    <script src="https://sdk.mercadopago.com/js/v2">
    </script>
</head>
<body>
    <div id="wallet_container">
    </div>
    <script>
      const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
        locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}'
      });

      mp.bricks().create("wallet", "wallet_container", {
        initialization: {
            preferenceId: "<PREFERENCE_ID>",
        },
      });
  </script>
</body>
</html>
        `,
        type: 'html',
        extension: 'html',
        value: 'javascript',
        name: 'javascript',
      },
      {
        code: `
import React, { useEffect } from 'react';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';

const YourComponent = () => {
    useEffect(() => {
      initMercadoPago('YOUR_PUBLIC_KEY', { locale: '${CountryOfOperationItems.getFormatedLanguageByCountry(formData.publicKey, formData.language)}' });
    }, []);

    return (
      <div>
        <Wallet initialization={{preferenceId: '<PREFERENCE_ID>'}} />
      </div>
    );
};

export default YourComponent;
        `,
        type: 'jsx',
        extension: 'jsx',
        value: 'react-jsx',
        name: 'react-jsx',
      },
    ];
  } catch (error) {
    console.log('error', error);
    log.warn('Error occurred while creating code front. Unable to complete the operation.');
    return [{
      code: '',
      type: 'html',
      name: 'html' }];
  }
};


module.exports = componentCodeFront;
